export default "__VITE_ASSET__DABRjqsC__"